import { KogTabsComponent } from "@/main/components/shared/tabs/tabs";
import { TabHierarchyLevels } from "@/main/screens/registration/insurer/insurerRegisterScreen/hierarchyLevels/tabHierarchyLevels";
import { Controls } from "@/main/services/constants/constantsControl";
import { SystemApplicationEnum } from "@/main/services/enum/SystemApplicationEnum";
import { getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";

export default function TabHierarchy() {
	const tabPanels = [
		{
			tab: getTranslateByKey("screen.PartsSystemApplication"),
			panel: <TabHierarchyLevels idSystemApplication={SystemApplicationEnum.Parts} />,
			isShowControl: isShowControlByElementId(Controls.IdHierarchyLevelsParts),
		},
		{
			tab: getTranslateByKey("screen.ClaimsSystemApplication"),
			panel: <TabHierarchyLevels idSystemApplication={SystemApplicationEnum.Claims} />,
			isShowControl: isShowControlByElementId(Controls.IdHierarchyLevelsClaims),
		},
	];
	return <KogTabsComponent tabCurrent={0} tabPanels={tabPanels} onChangeTab={() => {}} />;
}
